// 'use client'

// import Footer from '@/components/layouts/Footer'
// import Header from '@/components/layouts/Header'
// import { useI18n } from '@/providers/I18nProvider'
// import { useReportClientErrorMutation } from '@/services/report'
// import { useEffect } from 'react'

// const ErrorPage = ({ error }: { error?: Error }) => {
//   const { t } = useI18n()

//   const mutation = useReportClientErrorMutation()

//   useEffect(() => {
//     handleReport()
//   }, [])

//   const handleReport = () => {
//     const body = {
//       message: error?.message,
//       error: error?.message,
//       url: window.location.href,
//       type: 'app-error',
//       stack: error?.stack,
//       details: error,
//       userAgent: navigator.userAgent,
//     }
//     mutation.mutate(body)
//   }

//   return (
//     <>
//       <Header hideAction />
//       <div className="min-h-[calc(100vh-60px)] flex flex-col md:flex-row items-center justify-center bg-gray-50 px-4 py-8">
//         {/* Left: Illustration + 404 */}
//         <div className="flex flex-col items-center md:items-end md:w-1/2">
//           <img src="/images/error-image.png" alt="404 Illustration" className="w-full h-auto object-contain max-w-lg" />
//         </div>
//         {/* Right: Text + Button */}
//         <div className="mt-8 md:mt-0 md:ml-16 flex-1 flex flex-col items-center justify-center md:items-start text-center md:text-left ">
//           <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">{t('errorPage.title')}</h1>
//           <p className="text-lg md:text-xl text-gray-600 mb-6 text-center w-fit">{t('errorPage.description')}</p>
//           <a
//             href="/"
//             className="inline-block px-6 py-3 bg-green-600 text-white font-semibold rounded-full shadow hover:bg-green-700 transition"
//           >
//             {t('errorPage.backHome')}
//           </a>
//         </div>
//       </div>
//       <Footer hideContent />
//     </>
//   )
// }

// export default ErrorPage
'use client'

import Footer from '@/components/layouts/Footer'
import Header from '@/components/layouts/Header'  // LandingHeader đã sửa prop

const ErrorPage = ({ error }: { error?: Error & { digest?: string } }) => {
  // Optional: Log error ra console để debug (không cần report backend lúc này)
  if (error) {
    console.error('App Error:', error)
    console.error('Digest:', error.digest)  // Next.js cung cấp digest để trace lỗi
  }

  return (
    <>
      <Header hideAction />

      <div className="min-h-[calc(100vh-60px)] flex flex-col md:flex-row items-center justify-center bg-gray-50 px-4 py-8">
        {/* Left: Illustration */}
        <div className="flex flex-col items-center md:items-end md:w-1/2">
          <img
            src="/images/error-image.png"
            alt="Lỗi xảy ra"
            className="w-full h-auto object-contain max-w-lg"
          />
        </div>

        {/* Right: Text + Button */}
        <div className="mt-8 md:mt-0 md:ml-16 flex-1 flex flex-col items-center justify-center md:items-start text-center md:text-left">
          <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
            Ối! Có lỗi xảy ra
          </h1>
          <p className="text-lg md:text-xl text-gray-600 mb-6">
            Chúng tôi đang cố gắng sửa chữa. Vui lòng thử lại sau hoặc quay về trang chủ.
          </p>
          <a
            href="/"
            className="inline-block px-6 py-3 bg-green-600 text-white font-semibold rounded-full shadow hover:bg-green-700 transition"
          >
            Quay về trang chủ
          </a>
        </div>
      </div>

      <Footer hideContent />
    </>
  )
}

export default ErrorPage